import { useState } from 'react';
import { cccdAdmin, type DiscountType } from '@/lib/api/cccdAdminClient';
import { btnSave, inputCls, labelCls } from '@/components/admin/FormComponents';
import Alert from '@/components/ui/alert/Alert';
import { toastError } from '@/lib/toast';

const DISCOUNT_TYPES: { value: DiscountType; label: string }[] = [
  { value: 'none', label: 'Sin descuento' },
  { value: 'multi_team', label: 'Multi-equipo' },
  { value: 'historical', label: 'Histórico' },
  { value: 'scholarship', label: 'Beca' },
  { value: 'custom', label: 'Personalizado' },
];

export function TeamDiscountForm({
  teamId,
  currentType,
  currentPercent,
  onSaved,
}: {
  teamId: string;
  currentType: DiscountType;
  currentPercent: number;
  onSaved: () => void;
}) {
  const [type, setType] = useState(currentType);
  const [percent, setPercent] = useState(currentPercent);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    try {
      await cccdAdmin.updateTeam(teamId, { discountType: type, discountPercent: percent });
      onSaved();
    } catch (err: any) {
      const message = err?.response?.data?.error ?? 'Error al guardar descuento.';
      setError(message);
      toastError(message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex items-end gap-3 flex-wrap">
        <div>
          <label className={labelCls}>Tipo</label>
          <select
            className={inputCls}
            value={type}
            onChange={(e) => setType(e.target.value as DiscountType)}
          >
            {DISCOUNT_TYPES.map((d) => (
              <option key={d.value} value={d.value}>{d.label}</option>
            ))}
          </select>
        </div>
        <div>
          <label className={labelCls}>Porcentaje</label>
          <input
            type="number"
            min={0}
            max={100}
            className={`${inputCls} w-24`}
            value={percent}
            onChange={(e) => setPercent(Number(e.target.value))}
          />
        </div>
        <button type="button" onClick={handleSave} disabled={saving} className={btnSave}>
          {saving ? 'Guardando...' : 'Guardar'}
        </button>
      </div>
      {error && <Alert variant="error" title="No se pudo guardar el descuento" message={error} />}
    </div>
  );
}
